<template>
    <div class="footer-menu">
  <router-link  to="/dashboard" class="menu-item">
    <span class="icon"><i class="fa fa-home"></i></span>
    <span class="label">Dashboard</span>
  </router-link>
  
  <router-link  to="/gatepass"  class="menu-item">
    <span class="icon"><i class="fa fa-users"></i></span>
    <span class="label">Visitor Pass</span>
  </router-link>
  <router-link  to="/createEmployeeGatepass"  class="menu-item">
    <span class="icon"><i class="fa fa-ticket"></i></span>
    <span class="label">Gatepass</span>
  </router-link>
  <router-link  to="/profile"  class="menu-item">
    <span class="icon"><i class="fa fa-user"></i></span>
    <span class="label">Profile</span>
  </router-link>
</div>


    <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 footer-copyright text-center">
                <!--<p class="mb-0">Copyright 2024 © Application BY DK Techno's  </p>-->
              </div>
            </div>
          </div>
        </footer>
        
       
</template>
<style scoped>
.fa{
        font-size:larger;
}
 .footer-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--theme-deafult);
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
  z-index: 1000;
}

/* Hide by default */
.footer-menu {
  display: none;
}

/* Show only on screens smaller than 768px */
@media (max-width: 768px) {
  .footer-menu {
    display: flex;
  }
}
.label{
    font-size: 10px;
}
.footer-menu .menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  font-size: 12px;
  transition: color 0.3s;
}

.footer-menu .menu-item .icon {
  font-size: 20px;
  margin-bottom: 2px;
}

.footer-menu .menu-item:hover {
  color:#ffb500;
}
</style>

<script>


export default {
  name: 'FooterPart',
	mounted() {
		this.sidebar();

	},data() {
  return {
    iscalled:0,
    myInstance: null
  }
},
  onMounted(){ 
      
  },
    beforeMount() { 
    
      if(!this.isScriptLoaded(this.$cur_host+"assets/js/sidebar-menu.js")){
            const plugin = document.createElement("script");
            plugin.setAttribute("src",this.$cur_host+"assets/js/sidebar-menu.js");
            plugin.async = true;
            document.body.appendChild(plugin);

      }
       if(!this.isScriptLoaded(this.$cur_host+"assets/js/sidebar-pin.js")){
            const plugin2 = document.createElement("script");
            plugin2.setAttribute("src",this.$cur_host+"assets/js/sidebar-pin.js");
            plugin2.async = true;
            document.body.appendChild(plugin2);
            
      }
            if(!this.isScriptLoaded(this.$cur_host+"assets/js/script.js")){
            const plugin4 = document.createElement("script");
            plugin4.setAttribute("src",this.$cur_host+"assets/js/script.js");
            plugin4.async = true;
            document.body.appendChild(plugin4);
            }

            
},
    methods:{
      isScriptLoaded(src)
      {
          const existingScript = document.querySelector(`script[src="${src}"]`);
            if (existingScript) {
              existingScript.remove();
            }

        //   return Boolean(document.querySelector('script[src="' + src + '"]'));
      },

    sidebar(){
       
      if(this.iscalled==0){
          const toggle = document.getElementById("searchIcon");
          let newinput = false;
          if(toggle)
          toggle.addEventListener("click", function(){
              newinput = !newinput
              if(newinput){
              document.getElementById("searchInput").classList.add("show")
              }else{
              document.getElementById("searchInput").classList.remove("show")
              }
          });
          const pinTitle = document.querySelector(".pin-title");
          let pinIcon = document.querySelectorAll(".sidebar-list .fa-thumb-tack");

      }
      this.iscalled=1;
    }
  }
  
}
</script>
 
